// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"73cd8521","249":"6b9baeaf","361":"dbde9f26","583":"9efb809c","676":"faba0ffa","690":"dc43f746","722":"9ba95302"}[chunkId] + ".chunk.js";
};